import React, { useEffect, useState } from 'react';
import SidebarSites from '../components/SidebarSites';
import { loadScriptsSequentially } from '../utils';
import { useLocation, Link } from 'react-router-dom';

function Error() {

    useEffect(() => {

        // Carica jQuery e altri script necessari
        const script = document.createElement('script');
        script.src = "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" + Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]).then(() => {
                // Puoi inizializzare altri componenti qui se necessario
                // initializeComponents();
            });
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <>
            <section class="error_area bg_color">
                <div class="error_dot one"></div>
                <div class="error_dot two"></div>
                <div class="error_dot three"></div>
                <div class="error_dot four"></div>
                <div class="container">
                    <div class="error_content_two text-center">
                        <div class="error_img">
                            <img class="p_absolute error_shap" src="img/404_bg.png" alt="" />
                            <div class="one wow clipInDown" data-wow-delay="1s"><img class="img_one" src="img/404_two.png" alt="" /></div>
                            <div class="two wow clipInDown" data-wow-delay="1.5s"><img class="img_two" src="img/404_three.png" alt="" /></div>
                            <div class="three wow clipInDown" data-wow-delay="1.8s"><img class="img_three" src="img/404_one.png" alt="" /></div>
                        </div>
                        <h2>Errore, sei sicuro di aver digitato correttamente?</h2>
                        <p>Purtroppo non siamo stati ingrado di trovare la pagina o il percorso che stai cercando, riprova più tardi oppure torna alla home.</p>
                        {/* <form action="#" class="error_search">
                        <input type="text" class="form-control" placeholder="Search" />
                    </form> */}
                        <Link to="/" class="action_btn box_shadow_none"><i class="arrow_left"></i>Torna alla home</Link>
                    </div>
                </div>
            </section>
            <section className="doc_action_area_two">
                <div className="container">
                    <div className="doc_action_info mt_130">
                        <div className="row align-items-center">
                            <div className="col-lg-9">
                                <div className="media wow fadeInLeft">
                                    <img src="https://cdn.psicopaticiservice.com/logo/psi-v3-black-3.png" className='psico-micro-logo' alt="" />
                                    <div className="media-body">
                                        <h2 className="h_title">Hai bisogno di aiuto?</h2>
                                        <p>Scopri come migliorare la tua performance da partner con i nostri articoli dedicati.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 wow fadeInRight">
                                <Link to="/articles" className="action_btn">Vedi tutti gli articoli <i className="arrow_right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Error;

